module.exports = __webpack_public_path__ + "static/media/desktop.47a493b8.jpg";